import { render } from "./addManagerModal.vue?vue&type=template&id=22c7ca00&scoped=true"
import script from "./addManagerModal.vue?vue&type=script&lang=js"
export * from "./addManagerModal.vue?vue&type=script&lang=js"

import "./addManagerModal.vue?vue&type=style&index=0&id=22c7ca00&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c7ca00"]])

export default __exports__